import type { CostEstimate } from '@cartwheel/api/v1'

export function insuranceTypeLabel(type: CostEstimate['estimate_type']): string {
  switch (type) {
    case 'commercial':
      return 'Commercial'
    case 'medicaid':
      return 'Medicaid'
    case 'self_pay':
      return 'Self-Paid'
    case 'other':
      return 'Other'
  }
}
